// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as $$Promise from "common/src/Promise.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

var baseUrl = "https://ap.tft.tools";

function getPlayer(region, playerName, set, tag, param) {
  var set$1 = set === 10 ? 100 : set;
  var url = tag !== undefined ? baseUrl + "/player/stats2/" + Region.toApiName(region) + "/" + playerName + "/" + tag + "/" + String(set$1) + "/50" : baseUrl + "/player/stats/" + Region.toApiName(region) + "/" + playerName + "/" + String(set$1) + "/50";
  return $$Promise.map2($$Promise.flatMap(fetch(url), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var json = param[1];
                var status = param[0];
                if (status !== 200) {
                  if (status !== 404) {
                    return {
                            TAG: /* Error */1,
                            _0: [
                              region,
                              playerName,
                              /* Unknown */1
                            ]
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: [
                              region,
                              playerName,
                              /* NotFound */0
                            ]
                          };
                  }
                }
                var info_matches = Belt_Array.map(json.matches, T.removeHpTempTraits);
                var info_playerInfo = json.playerInfo;
                var info_rankHistory = json.rankHistory;
                var info_duoRankHistory = json.duoRankHistory;
                var info_hrRankHistory = json.hrRankHistory;
                var info_seasonStats = json.seasonStats;
                var info_queueSeasonStats = json.queueSeasonStats;
                var info_pendingQueueId = json.pendingQueueId;
                var info = {
                  matches: info_matches,
                  playerInfo: info_playerInfo,
                  rankHistory: info_rankHistory,
                  duoRankHistory: info_duoRankHistory,
                  hrRankHistory: info_hrRankHistory,
                  seasonStats: info_seasonStats,
                  queueSeasonStats: info_queueSeasonStats,
                  pendingQueueId: info_pendingQueueId
                };
                return {
                        TAG: /* Ok */0,
                        _0: info
                      };
              }), (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: [
                          region,
                          playerName,
                          /* Unknown */1
                        ]
                      };
              }));
}

function getPlayerCached(region, playerName, set, tag, param) {
  var set$1 = set === 10 ? 100 : set;
  var url = tag !== undefined ? baseUrl + "/stats-cached2/" + Region.toApiName(region) + "/" + playerName + "/" + tag + "/" + String(set$1) + "/50" : baseUrl + "/stats-cached/" + Region.toApiName(region) + "/" + playerName + "/" + String(set$1) + "/50";
  return $$Promise.map2($$Promise.flatMap(fetch(url), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var json = param[1];
                var status = param[0];
                if (status !== 200) {
                  if (status !== 404) {
                    return {
                            TAG: /* Error */1,
                            _0: [
                              region,
                              playerName,
                              /* Unknown */1
                            ]
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: [
                              region,
                              playerName,
                              /* NotFound */0
                            ]
                          };
                  }
                }
                var info_matches = Belt_Array.map(json.matches, T.removeHpTempTraits);
                var info_playerInfo = json.playerInfo;
                var info_rankHistory = json.rankHistory;
                var info_duoRankHistory = json.duoRankHistory;
                var info_hrRankHistory = json.hrRankHistory;
                var info_seasonStats = json.seasonStats;
                var info_queueSeasonStats = json.queueSeasonStats;
                var info_pendingQueueId = json.pendingQueueId;
                var info = {
                  matches: info_matches,
                  playerInfo: info_playerInfo,
                  rankHistory: info_rankHistory,
                  duoRankHistory: info_duoRankHistory,
                  hrRankHistory: info_hrRankHistory,
                  seasonStats: info_seasonStats,
                  queueSeasonStats: info_queueSeasonStats,
                  pendingQueueId: info_pendingQueueId
                };
                return {
                        TAG: /* Ok */0,
                        _0: info
                      };
              }), (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: [
                          region,
                          playerName,
                          /* Unknown */1
                        ]
                      };
              }));
}

function getMasterRanks(region, set) {
  var set$1 = set === 10 ? 100 : set;
  return $$Promise.map($$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/player/master-ranks/" + Region.toApiName(region) + "/" + String(set$1)), (function (prim) {
                        return prim.json();
                      })), (function (prim) {
                    return prim;
                  })), (function (mr) {
                return {
                        challenger: Belt_Array.map(mr.challenger, (function (param) {
                                var ts = param[0];
                                if (ts < 1680296400) {
                                  return [
                                          ts,
                                          500
                                        ];
                                } else {
                                  return [
                                          ts,
                                          param[1]
                                        ];
                                }
                              })),
                        grandmaster: Belt_Array.map(mr.grandmaster, (function (param) {
                                var ts = param[0];
                                if (ts < 1680296400) {
                                  return [
                                          ts,
                                          200
                                        ];
                                } else {
                                  return [
                                          ts,
                                          param[1]
                                        ];
                                }
                              })),
                        top1: mr.top1,
                        top10: mr.top10,
                        top25: mr.top25,
                        top50: mr.top50
                      };
              }));
}

function getRankedGames(region, playerName, set, tag, param) {
  var set$1 = set === 10 ? 100 : set;
  var url = tag !== undefined ? baseUrl + "/player/matches/" + Region.toApiName(region) + "/" + playerName + "/" + tag + "/" + String(set$1) + "/1100" : baseUrl + "/player/matches/ranked/" + Region.toApiName(region) + "/" + playerName + "/" + String(set$1);
  return $$Promise.map($$Promise.flatMap(fetch(url), (function (prim) {
                    return prim.json();
                  })), (function (prim) {
                return prim;
              }));
}

function getNormalGames(region, playerName, set, tag, param) {
  var set$1 = set === 10 ? 100 : set;
  var url = tag !== undefined ? baseUrl + "/player/matches/" + Region.toApiName(region) + "/" + playerName + "/" + tag + "/" + String(set$1) + "/1090" : baseUrl + "/player/matches/normal/" + Region.toApiName(region) + "/" + playerName + "/" + String(set$1);
  return $$Promise.map($$Promise.flatMap(fetch(url), (function (prim) {
                    return prim.json();
                  })), (function (prim) {
                return prim;
              }));
}

function getHrGames(region, playerName, set, tag, param) {
  var set$1 = set === 10 ? 100 : set;
  var url = tag !== undefined ? baseUrl + "/player/matches/" + Region.toApiName(region) + "/" + playerName + "/" + tag + "/" + String(set$1) + "/1130" : baseUrl + "/player/matches/hr/" + Region.toApiName(region) + "/" + playerName + "/" + String(set$1);
  return $$Promise.map($$Promise.flatMap(fetch(url), (function (prim) {
                    return prim.json();
                  })), (function (prim) {
                return prim;
              }));
}

function getDuoGames(region, playerName, set, tag, param) {
  var set$1 = set === 10 ? 100 : set;
  var url = tag !== undefined ? baseUrl + "/player/matches/" + Region.toApiName(region) + "/" + playerName + "/" + tag + "/" + String(set$1) + "/1160" : baseUrl + "/player/matches/duo/" + Region.toApiName(region) + "/" + playerName + "/" + String(set$1);
  return $$Promise.map($$Promise.flatMap(fetch(url), (function (prim) {
                    return prim.json();
                  })), (function (prim) {
                return prim;
              }));
}

function getMatch(matchId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://api.tft.tools/match/" + matchId), (function (prim) {
                    return prim.json();
                  })), (function (prim) {
                return prim;
              }));
}

function getReviewData(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://legendsapi.com/review-data/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                if (param[0] === 200) {
                  return param[1];
                }
                
              }));
}

function getReviewData6(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://legendsapi.com/review-data6/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData65(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://legendsapi.com/review-datatmp/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData7(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://legendsapi.com/review-data-tmp7/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData75(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://legendsapi.com/review-data-75/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData8(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://legendsapi.com/review-data-8-tmp/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData85(region, playerName, queueId) {
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-85/" + Region.toApiName(region) + "/" + playerName + "/" + String(queueId)), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData9(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-9/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData95(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-95/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData10(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-100/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData11(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-110/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData36(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-36/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData56(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-56/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData12(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-120/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData46(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-46/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

function getReviewData13(player) {
  var tag = player.tag;
  var tagStr = tag !== undefined ? "?tag=" + tag : "";
  return $$Promise.map($$Promise.flatMap(fetch("https://ap.tft.tools/wrapped/set-130/" + Region.toApiName(player.region) + "/" + player.playerName + "/" + String(player.queueId) + tagStr), (function (resp) {
                    return Promise.all([
                                Promise.resolve(resp.status),
                                resp.json()
                              ]);
                  })), (function (param) {
                var status = param[0];
                if (status === 200) {
                  return {
                          TAG: /* Ok */0,
                          _0: param[1]
                        };
                } else if (status === 404) {
                  return {
                          TAG: /* Error */1,
                          _0: 404
                        };
                } else {
                  return {
                          TAG: /* Error */1,
                          _0: 500
                        };
                }
              }));
}

export {
  baseUrl ,
  getPlayer ,
  getPlayerCached ,
  getMasterRanks ,
  getRankedGames ,
  getNormalGames ,
  getHrGames ,
  getDuoGames ,
  getMatch ,
  getReviewData ,
  getReviewData6 ,
  getReviewData65 ,
  getReviewData7 ,
  getReviewData75 ,
  getReviewData8 ,
  getReviewData85 ,
  getReviewData9 ,
  getReviewData95 ,
  getReviewData10 ,
  getReviewData11 ,
  getReviewData36 ,
  getReviewData56 ,
  getReviewData12 ,
  getReviewData46 ,
  getReviewData13 ,
  
}
/* T Not a pure module */
